import { useEffect, useState } from 'react';

const Details = () => {
  return <></>;
};

export default Details;
